import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SELECT_POSTGRADO(state, item) {
            state.value = item;
        },
        SET_POSTGRADOS(state, items = []) {
            state.items = [...state.items, ...items];
        },
        ADD_POSTGRADO(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_POSTGRADO(state, Id) {
            const ind = state.items.findIndex(postgrado => postgrado.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_POSTGRADO(state, { Id, postgrado }) {
            const ind = state.items.findIndex(postgrado => postgrado.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, postgrado);
            }
        }
    },

    actions: {
        selectPostgrado({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('SELECT_POSTGRADO', data), true) : false;
        },

        setPostgrados({ state, commit }, data = []) {
            data.forEach(postgrado => {
                if (!state.items.find(item => item.id == postgrado.id)) {
                    commit('ADD_POSTGRADO', postgrado);
                }
            });
            return true;
        },

        addPostgrado({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_POSTGRADO', data), true) : false;
        },

        deletePostgrado({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_POSTGRADO', id), true) : false;
        },

        // editPostgrado({ commit }, data) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             commit('EDIT_POSTGRADO', data);
        //             resolve();
        //         }, 250);
        //     });
        // }
    }
};
